import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { CustomerAuthSessionService } from '../services/customer-auth-session.service';

/** Adds `Authorization: Bearer <token>` when a customer session token exists. */
export const customerAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(CustomerAuthSessionService);
  const token = session.accessToken()?.trim();
  if (!token || req.headers.has('Authorization')) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
